.resource {
  font-size: 18px;
  min-width: 0;

  &.tag-resource {
    gap: 8px;
  }
}

.wrapper-resource {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.name-resource {
  font-size: var(--cell-table-font-size);
  line-height: normal;

  > a,
  a:hover {
    color: var(--neutral-10-color);
    text-decoration: underline;
  }
}

.tag {
  font-size: var(--sm-font-size);
}

.column {
  display: flex;
  flex-direction: column;
}

.container {
  justify-content: center;
  max-width: fit-content;
}

.section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
}

.container-resources {
  height: 22px;
}

.container-resources-inline {
  height: 20px;
}

.name-resources {
  font-size: var(--md-font-size);
  font-weight: 500;
}

%line-height-inline {
  line-height: 20px;
}

.name-resources-inline {
  @extend %line-height-inline;
}

.placement-drawer {
  font-weight: 400;
  color: var(--neutral-7-color);

  > div > span {
    line-height: 1;
  }

  > span:last-child {
    margin: 2px 0 0;
  }

  svg {
    color: var(--neutral-7-color);
  }
}

.name-related-resources {
  color: var(--neutral-7-color);
  font-size: var(--cell-table-font-size);

  &.inline {
    @extend %line-height-inline;

    font-size: var(--sm-font-size);
    white-space: nowrap;
  }
}

.root-tooltip {
  :global {
    .ant-popover-container {
      padding: 0;
    }
  }
}

.container-tooltip {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  max-height: 199px;

  u {
    cursor: pointer;
  }
}

.copyable-wrapper {
  align-items: flex-start;

  > div {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
}

.content-single-resource-popover {
  svg {
    margin: 0.5em 0 0;
  }
}

.related-resources-count {
  transform: translateY(-1px);
}
